<template>
  <div class="tile is-parent is-12 is-vertical">
    <article class="tile is-child box">
      <div class="container is-child" style="margin-top:5px;">
        <h1 class="title has-text-centered">{{heading}} - {{total}} Entries</h1>
        <button class="button is-success is-large" @click="emitNew">New Item</button>
        <div class="table__wrapper">
      <table class="table is-responsive is-striped is-fullwidth" style="overflow-x: auto;">
        <thead>
          <th v-for="heading in headers" v-bind:key="heading">
            {{heading}}
          </th>
          <th>Validate</th>
          <th>Edit</th>
          <th>Delete</th>
        </thead>
        <tbody>
          <tr v-for="row in tableData" v-bind:key="row.id"> 
            <td v-for="data in row" v-bind:key="data.id" v-bind:class="{'unverified': row.is_verified == 0,  'verified': row.is_verified != 0}" class="colourdtd">{{data}}</td>
              <td v-bind:class="{'unverified': row.is_verified == 0,  'verified': row.is_verified != 0}"><button class="button is-success is-small" v-on:click="validate(row)"><div v-if="row.is_verified==0">Validate</div><div v-else  style="color:white;">Invalidate</div></button></td>
              <td v-bind:class="{'unverified': row.is_verified == 0,  'verified': row.is_verified != 0}"><button class="button is-warning is-small" v-on:click="edit(row)">Edit</button></td>
              <td v-bind:class="{'unverified': row.is_verified == 0,  'verified': row.is_verified != 0}"><button class="button is-danger is-small"  v-on:click="del(row)">Delete</button></td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
    </article>
  </div>
</template>
<script>
import Notification from 'vue-bulma-notification'
import Vue from 'vue'
const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}
export default {
  props: ['heading', 'headers', 'tableData', 'total', 'openNew'],
  components: {
    Notification
  },
  data () {
    return {
    }
  },
  methods: {
    edit: function (data) {
      // console.log('EDIT: ' + JSON.stringify(data))
      this.$emit('edit', data)
    },
    validate: function (data) {
      console.log('Validate: ' + JSON.stringify(data))
      this.verifyRecord(data.id, data.is_verified)
    },
    del: function (data) {
      console.log('Delete: ' + JSON.stringify(data))
      this.deleteRecord(data.id)
    },
    deleteRecord (recordId) {
      let url = 'https://devilsapi.roblutken.com/api/delete-record/' + recordId
      this.$http.get(url,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        if (response.data.status === 202) {
          openNotification({
            title: 'Deleted Item',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
          this.$emit('reload')
        } else {
          openNotification({
            title: 'Error Validating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
    },
    verifyRecord (recordId, isVerified) {
      console.log('Validate record: ' + recordId)
      let url = ''
      if (isVerified === 0) {
        url = 'https://devilsapi.roblutken.com/api/verify-record/' + recordId
      } else {
        url = 'https://devilsapi.roblutken.com/api/invalidate-record/' + recordId
      }
      this.$http.get(url,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        if (response.data.status === 202) {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
          this.$emit('reload')
        } else {
          openNotification({
            title: 'Error Validating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
    },
    emitNew () {
      this.$emit('new')
    },
    openNotificationWithType (type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      })
    }
  },
  mounted () {
    // console.log('Edit Table Data is: ' + this.total)
  }
}
</script>
<style>
.table__wrapper {
  overflow-x: auto;
}
.colourdtd{
  background-color:black;
}
.verified{
  background-color: rgb(0, 100, 0);
  color:whitesmoke;
}
.unverified{
  background-color: rgb(255, 239, 239);
  color:black;
}
.table thead td, .table thead th {
  font-family: 'Coda', cursive;
  text-transform: uppercase;
}
.table td {
    font-family: 'Coda', cursive;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// edit-table.vue?14deaf4b